import type { LuggageTypes } from '@lt/api/dist/methods/packages/types';
import React from 'react';
import styled from 'styled-components';
import { getDaysDiff } from 'src/utils/dateUtils';
import { useTranslation } from '@lt/localization';
import FlightsOneWayInfo from './components/FlightOneWayInfo';

export type FlightInfo = {
  departureTime?: string;
  arrivalTime?: string;
  date: string;
  luggage: LuggageTypes;
};

type Props = {
  to: FlightInfo;
  back: FlightInfo;
  isFlightChangable: boolean;
};

const FlightsTime = (props: Props) => {
  const { to, back, isFlightChangable } = props;

  const { t } = useTranslation();
  const changableTime = t('checkout.sidebar.changableTime');

  const toDaysDiff = getDaysDiff(to.departureTime, to.arrivalTime);
  const backDaysDiff = getDaysDiff(back.departureTime, back.arrivalTime);

  return (
    <Wrapper>
      {isFlightChangable && changableTime}
      <StyledFlightsContainer>
        <FlightsOneWayInfo
          daysDiff={toDaysDiff}
          direction={to}
          isFlightChangable={isFlightChangable}
        />
        <FlightsBackInfo
          daysDiff={backDaysDiff}
          direction={back}
          isFlightChangable={isFlightChangable}
          isDirectionBack
        />
      </StyledFlightsContainer>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

const StyledFlightsContainer = styled.div`
  display: flex;
  width: 304px;
  align-items: flex-start;
  gap: 4px;
`;

const FlightsBackInfo = styled(FlightsOneWayInfo)`
  padding-left: 8px;

  border-color: #e6e9ee;
  border-style: solid;
  border-width: 0 0 0 1px;
`;

export default FlightsTime;
